
// import React from "react";

// const Filters = ({
//   filterOptions = { parentDomains: [], domains: [], subDomains: [], products: [] },
//   parentDomain,
//   domain,
//   subDomain,
//   product,
//   onParentDomainChange,
//   onDomainChange,
//   onSubDomainChange,
//    onReset,
//   onProductChange,
// }) => {
//   return (
//     <div className="dash-filters">
//   {/* Parent Domain */}
//    <div className="dash-filter-group">
//         <label className="dash-filter-label">Parent Domain</label>
//   <select
//     className="dash-select"
//     value={parentDomain}
//     onChange={onParentDomainChange}
//   >
//     <option>All Parent Domains</option>
//     {(filterOptions.parentDomains || []).map((pd) => (
//       <option key={pd.parent_domain_id}>{pd.parent_domain}</option>
//     ))}
//   </select>
//   </div>

//   {/* Domain */}
//    <div className="dash-filter-group">
//         <label className="dash-filter-label"> Domains</label>
//   <select
//     className="dash-select"
//     value={domain}
//     onChange={onDomainChange}
//   >
//     <option>All Domains</option>
//     {(filterOptions.domains || []).map((d) => (
//       <option key={d.domain_id}>{d.domain}</option>
//     ))}
//   </select>
// </div>
//   {/* SubDomain */}
//    <div className="dash-filter-group">
//         <label className="dash-filter-label">Sub Domains</label>
//   <select
//     className="dash-select"
//     value={subDomain}
//     onChange={onSubDomainChange}
//   >
//     <option>All Sub Domains</option>
//     {(filterOptions.subDomains || []).map((sd) => (
//       <option key={sd.sub_domain_id}>{sd.sub_domain}</option>
//     ))}
//   </select>
// </div>
//   {/* Product */}
//    <div className="dash-filter-group">
//         <label className="dash-filter-label"> Products</label>
//   <select
//     className="dash-select"
//     value={product}
//     onChange={onProductChange}
//   >
//     <option>All Products</option>
//     {(filterOptions.products || []).map((p, i) => (
//       <option key={i}>{p}</option>
//     ))}
//   </select>
// </div>
//   <div className="dash-filter-group" style={{marginTop:'25px'}}>
// <button  onClick={onReset} className="px-3 py-2 h-[38px] border border-[#E8E8EB] rounded text-[14px] bg-white cursor-pointer text-[#747474] font-poppins not-italic font-normal">
//   Reset
// </button>
// </div>
// </div>
//   );
// };

// export default Filters;

import React from "react";
import { FormControl, Select, MenuItem, Button } from "@mui/material";

const Filters = ({
  filterOptions = { parentDomains: [], domains: [], subDomains: [], products: [] },
  parentDomain,
  domain,
  subDomain,
  product,
  onParentDomainChange,
  onDomainChange,
  onSubDomainChange,
  onProductChange,
  onReset,
}) => {
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "auto",
      },
    },
  };

  // Helper: fallback to "All ..." if value is empty
  const getDisplayValue = (value, defaultLabel) =>
    value === "" || value === undefined ? defaultLabel : value;

  return (
    <div className="dash-filters">
      {/* Parent Domain */}
      <div className="dash-filter-group">
        <label className="dash-filter-label">Parent Domain</label>
        <FormControl fullWidth>
          <Select
            value={parentDomain || ""}
            onChange={onParentDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Parent Domains"
            }
          >
            <MenuItem value="">All Parent Domains</MenuItem>
            {(filterOptions.parentDomains || []).map((pd) => (
              <MenuItem key={pd.parent_domain_id} value={pd.parent_domain}>
                {pd.parent_domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Domain */}
      <div className="dash-filter-group">
        <label className="dash-filter-label">Domains</label>
        <FormControl fullWidth>
          <Select
            value={domain || ""}
            onChange={onDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Domains"
            }
          >
            <MenuItem value="">All Domains</MenuItem>
            {(filterOptions.domains || []).map((d) => (
              <MenuItem key={d.domain_id} value={d.domain}>
                {d.domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Sub Domain */}
      <div className="dash-filter-group">
        <label className="dash-filter-label">Sub Domains</label>
        <FormControl fullWidth>
          <Select
            value={subDomain || ""}
            onChange={onSubDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Sub Domains"
            }
          >
            <MenuItem value="">All Sub Domains</MenuItem>
            {(filterOptions.subDomains || []).map((sd) => (
              <MenuItem key={sd.sub_domain_id} value={sd.sub_domain}>
                {sd.sub_domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Product */}
      <div className="dash-filter-group">
        <label className="dash-filter-label">Products</label>
        <FormControl fullWidth>
          <Select
            value={product || ""}
            onChange={onProductChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Products"
            }
          >
            <MenuItem value="">All Products</MenuItem>
            {(filterOptions.products || []).map((p, i) => (
              <MenuItem key={i} value={p}>
                {p}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Reset */}
      <div className="dash-filter-group" style={{ marginTop: "25px" }}>
        <Button
          onClick={onReset}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderColor: "#E8E8EB",
            color: "#747474",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            height: "38px",
            backgroundColor: "white",
            // "&:hover": { borderColor: "#B0B0B0" },
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default Filters;



// Filters.jsx
// // Filters.jsx
// import React from "react";
// import ReactSelect from "react-select";

// const defaultMaxMenuHeight = 180; // px — adjust if needed

// const toOptions = (arr, valueKey, labelKey) =>
//   (arr || []).map((it) =>
//     typeof it === "string" ? { value: it, label: it } : { value: it[valueKey], label: it[labelKey] }
//   );

// const Filters = ({
//   filterOptions = { parentDomains: [], domains: [], subDomains: [], products: [] },
//   parentDomain,
//   domain,
//   subDomain,
//   product,
//   onParentDomainChange,
//   onDomainChange,
//   onSubDomainChange,
//   onReset,
//   onProductChange,
// }) => {
//   const commonStyles = {
//     control: (base) => ({
//       ...base,
//       background: "transparent",
//       border: "none",
//       boxShadow: "none",
//       minHeight: "38px",
//       height: "100%",
//       padding: 0,
//     }),
//     valueContainer: (base) => ({ ...base, padding: "0 6px" }),
//     indicatorsContainer: (base) => ({ ...base, padding: 0 }),
//     singleValue: (base) => ({
//       ...base,
//       margin: 0,
//       padding: 0,
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       textOverflow: "ellipsis",
//     }),
//     menu: (base) => ({ ...base, maxHeight: defaultMaxMenuHeight, overflowY: "auto" }),
//     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//     option: (base) => ({ ...base, whiteSpace: "nowrap" }),
//   };

//   // build option arrays once
//   const parentOptions = toOptions(filterOptions.parentDomains, "parent_domain_id", "parent_domain");
//   const domainOptions = toOptions(filterOptions.domains, "domain_id", "domain");
//   const subDomainOptions = toOptions(filterOptions.subDomains, "sub_domain_id", "sub_domain");
//   const productOptions = toOptions(filterOptions.products); // products assumed array of strings

//   return (
//     <div className="dash-filters">
//       {/* Parent Domain */}
//       <div className="dash-filter-group">
//         <label className="dash-filter-label">Parent Domain</label>
//         <div className="dash-select" style={{ width: "100%" }}>
//           <ReactSelect
//             styles={commonStyles}
//             options={parentOptions}
//             value={parentOptions.find((o) => String(o.value) === String(parentDomain)) || null}
//             onChange={(sel) => onParentDomainChange({ target: { value: sel?.value || "" } })}
//             placeholder="All Parent Domains"
//             isSearchable={false}
//             menuPortalTarget={typeof document !== "undefined" ? document.body : null}
//             menuPlacement="auto"
//           />
//         </div>
//       </div>

//       {/* Domain */}
//       <div className="dash-filter-group">
//         <label className="dash-filter-label"> Domains</label>
//         <div className="dash-select" style={{ width: "100%" }}>
//           <ReactSelect
//             styles={commonStyles}
//             options={domainOptions}
//             value={domainOptions.find((o) => String(o.value) === String(domain)) || null}
//             onChange={(sel) => onDomainChange({ target: { value: sel?.value || "" } })}
//             placeholder="All Domains"
//             isSearchable={false}
//             menuPortalTarget={typeof document !== "undefined" ? document.body : null}
//             menuPlacement="auto"
//           />
//         </div>
//       </div>

//       {/* SubDomain */}
//       <div className="dash-filter-group">
//         <label className="dash-filter-label">Sub Domains</label>
//         <div className="dash-select" style={{ width: "100%" }}>
//           <ReactSelect
//             styles={commonStyles}
//             options={subDomainOptions}
//             value={subDomainOptions.find((o) => String(o.value) === String(subDomain)) || null}
//             onChange={(sel) => onSubDomainChange({ target: { value: sel?.value || "" } })}
//             placeholder="All Sub Domains"
//             isSearchable={false}
//             menuPortalTarget={typeof document !== "undefined" ? document.body : null}
//             menuPlacement="auto"
//           />
//         </div>
//       </div>

//       {/* Product */}
//       <div className="dash-filter-group">
//         <label className="dash-filter-label"> Products</label>
//         <div className="dash-select" style={{ width: "100%" }}>
//           <ReactSelect
//             styles={commonStyles}
//             options={productOptions}
//             value={productOptions.find((o) => String(o.value) === String(product)) || null}
//             onChange={(sel) => onProductChange({ target: { value: sel?.value || "" } })}
//             placeholder="All Products"
//             isSearchable={false}
//             menuPortalTarget={typeof document !== "undefined" ? document.body : null}
//             menuPlacement="auto"
//           />
//         </div>
//       </div>

//       <div className="dash-filter-group" style={{ marginTop: "25px" }}>
//         <button
//           onClick={onReset}
//           className="px-3 py-2 h-[38px] border border-[#E8E8EB] rounded text-[14px] bg-white cursor-pointer text-[#747474] font-poppins not-italic font-normal"
//         >
//           Reset
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Filters;

